<template>
  <div v-show="showHeaderMenu">
    <div class="saved-card-slider-wrapper">
      <div v-if="showSavedCardsEmptyState" class="h-100 d-flex align-items-center justify-content-center">
        Saved Cards appear here
      </div>
      <div v-else :class="getSavedCardSliderClass()" >
        <!-- If we need navigation buttons -->
        <div ref="savedCardSwiperPrevious" class="swiper-button-prev">
          <img src="/img/prev-button.png" width="29" alt="wRatings" />
        </div>

        <div ref="savedCardSwiper" class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(clientChart, idxClientChart) in this.displayedSavedCards" :key="idxClientChart">

                <chart-card :chart-card-object="clientChart" :clientChartIds="$parent.clientChartIds" :setType="setType" :viewType="viewType" 
                            @delete="resetClientCharts" @update="updateCardListForReport"/>
            </div>
          </div>
        </div>

        <div ref="savedCardSwiperNext" class="swiper-button-next">
          <img src="/img/next-button.png" width="29" alt="wRatings" />
        </div>
        <!-- If we need scrollbar -->
        <div class="d-none swiper-scrollbar"></div>
      </div>
      <!-- If we need pagination -->
      <!-- <div class="swiper-pagination"></div> -->

    </div>
  </div>
</template>
<script>
import Swiper, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

// Import Swiper Vue.js components
Swiper.use([ Navigation, Pagination, Scrollbar, A11y ]);

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';


import router from "../../router";
import Vue from "vue";
import MenuMixins from "../../mixins/MenuMixins.vue";
import SavedCardMixins from "../../mixins/SavedCardMixins.vue";
import ChartCard from "../../components/chart/ChartCard.vue";
import UserService from "../../services/user.service";
import {useRouter} from "vue-router";
Vue.use(useRouter);

export default {
  name: "SavedCardMenu",
  components: {ChartCard},
  mixins: [MenuMixins,SavedCardMixins],
  router,
  props: {},
  data() {
    return {
      swiper: null
    };
  },
  methods: {
    initializeSwiper() {
      if (this.swiper || !this.$refs.savedCardSwiper) {
        return;
      }
      this.swiper = new Swiper(this.$refs.savedCardSwiper, {
        modules: [Navigation, Pagination, Scrollbar, A11y],
        loop: false,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: this.$refs.savedCardSwiperNext,
          prevEl: this.$refs.savedCardSwiperPrevious,
        },
        breakpoints: {
          1350: {
            slidesPerView: 7,
          },
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 4,
          },
          0: {
            slidesPerView: 2,
          },
        },
      });
    },
    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
    getSavedCardSliderClass() {
      let baseClass = "saved-card-slider-slider";
      if (this.displayedSavedCards.length < 7) {
        baseClass += " small-card-slider";
      }
      return baseClass;
    },
    buildSavedCardTable() {
      this.cardsToShow = this.originalSavedCards.length;
      this.getDisplayedSavedCards();
      // filter dashboard cards
      this.displayedSavedCards = this.displayedSavedCards.filter(card => {
        return card.dashboardCardId == 0;
      });
    },
    updateCardListForReport(){}
  },
  created() {},
  mounted() {
    this.showCards = true;
    if (this.showCards == true){
      this.buildSavedCardTable();
    }
    this.$nextTick(() => {
      this.initializeSwiper();
    });
  },
  watch: {
    displayedSavedCards() {
      this.$nextTick(() => {
        if (this.showSavedCardsEmptyState) {
          this.destroySwiper();
        } else if (this.swiper) {
          this.swiper.update();
        } else {
          this.initializeSwiper();
        }
      });
    }    
  },
  computed: {
    showSavedCardsEmptyState() {
      return this.displayedSavedCards.length == 0;
    }
  },
  unmounted() {
    this.destroySwiper();
  }
};
</script>
